import { render, staticRenderFns } from "./TenderDiscounts.vue?vue&type=template&id=1812818b&scoped=true"
import script from "./TenderDiscounts.vue?vue&type=script&lang=js"
export * from "./TenderDiscounts.vue?vue&type=script&lang=js"
import style0 from "./TenderDiscounts.vue?vue&type=style&index=0&id=1812818b&prod&scoped=true&lang=scss"
import style1 from "./TenderDiscounts.vue?vue&type=style&index=1&id=1812818b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812818b",
  null
  
)

export default component.exports